// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteOrganizationModal_dialog__3EdGX","container":"DeleteOrganizationModal_container__3d5Ko"};